/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type UpdateScopedApiKeyAuthApiKeysResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class UpdateScopedApiKeyAuthApiKeysResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: UpdateScopedApiKeyAuthApiKeysResponse429ResponseBodyData;

  constructor(
    err: UpdateScopedApiKeyAuthApiKeysResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateScopedApiKeyAuthApiKeysResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type UpdateScopedApiKeyAuthApiKeysResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class UpdateScopedApiKeyAuthApiKeysResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: UpdateScopedApiKeyAuthApiKeysResponse409ResponseBodyData;

  constructor(
    err: UpdateScopedApiKeyAuthApiKeysResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateScopedApiKeyAuthApiKeysResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type UpdateScopedApiKeyAuthApiKeysResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class UpdateScopedApiKeyAuthApiKeysResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: UpdateScopedApiKeyAuthApiKeysResponse404ResponseBodyData;

  constructor(
    err: UpdateScopedApiKeyAuthApiKeysResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateScopedApiKeyAuthApiKeysResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type UpdateScopedApiKeyAuthApiKeysResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class UpdateScopedApiKeyAuthApiKeysResponseResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: UpdateScopedApiKeyAuthApiKeysResponseResponseBodyData;

  constructor(
    err: UpdateScopedApiKeyAuthApiKeysResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateScopedApiKeyAuthApiKeysResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type UpdateScopedApiKeyAuthApiKeysResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class UpdateScopedApiKeyAuthApiKeysResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: UpdateScopedApiKeyAuthApiKeysResponseBodyData;

  constructor(
    err: UpdateScopedApiKeyAuthApiKeysResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateScopedApiKeyAuthApiKeysResponseBody";
  }
}

/**
 * Bad request
 */
export type UpdateScopedApiKeyResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class UpdateScopedApiKeyResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: UpdateScopedApiKeyResponseBodyData;

  constructor(
    err: UpdateScopedApiKeyResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "UpdateScopedApiKeyResponseBody";
  }
}

/** @internal */
export const UpdateScopedApiKeyAuthApiKeysResponse429ResponseBody$inboundSchema:
  z.ZodType<
    UpdateScopedApiKeyAuthApiKeysResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new UpdateScopedApiKeyAuthApiKeysResponse429ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type UpdateScopedApiKeyAuthApiKeysResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateScopedApiKeyAuthApiKeysResponse429ResponseBody$outboundSchema:
  z.ZodType<
    UpdateScopedApiKeyAuthApiKeysResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    UpdateScopedApiKeyAuthApiKeysResponse429ResponseBody
  > = z.instanceof(UpdateScopedApiKeyAuthApiKeysResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UpdateScopedApiKeyAuthApiKeysResponse409ResponseBody$inboundSchema:
  z.ZodType<
    UpdateScopedApiKeyAuthApiKeysResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new UpdateScopedApiKeyAuthApiKeysResponse409ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type UpdateScopedApiKeyAuthApiKeysResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateScopedApiKeyAuthApiKeysResponse409ResponseBody$outboundSchema:
  z.ZodType<
    UpdateScopedApiKeyAuthApiKeysResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    UpdateScopedApiKeyAuthApiKeysResponse409ResponseBody
  > = z.instanceof(UpdateScopedApiKeyAuthApiKeysResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UpdateScopedApiKeyAuthApiKeysResponse404ResponseBody$inboundSchema:
  z.ZodType<
    UpdateScopedApiKeyAuthApiKeysResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new UpdateScopedApiKeyAuthApiKeysResponse404ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type UpdateScopedApiKeyAuthApiKeysResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateScopedApiKeyAuthApiKeysResponse404ResponseBody$outboundSchema:
  z.ZodType<
    UpdateScopedApiKeyAuthApiKeysResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    UpdateScopedApiKeyAuthApiKeysResponse404ResponseBody
  > = z.instanceof(UpdateScopedApiKeyAuthApiKeysResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UpdateScopedApiKeyAuthApiKeysResponseResponseBody$inboundSchema:
  z.ZodType<
    UpdateScopedApiKeyAuthApiKeysResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new UpdateScopedApiKeyAuthApiKeysResponseResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type UpdateScopedApiKeyAuthApiKeysResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateScopedApiKeyAuthApiKeysResponseResponseBody$outboundSchema:
  z.ZodType<
    UpdateScopedApiKeyAuthApiKeysResponseResponseBody$Outbound,
    z.ZodTypeDef,
    UpdateScopedApiKeyAuthApiKeysResponseResponseBody
  > = z.instanceof(UpdateScopedApiKeyAuthApiKeysResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UpdateScopedApiKeyAuthApiKeysResponseBody$inboundSchema: z.ZodType<
  UpdateScopedApiKeyAuthApiKeysResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new UpdateScopedApiKeyAuthApiKeysResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type UpdateScopedApiKeyAuthApiKeysResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateScopedApiKeyAuthApiKeysResponseBody$outboundSchema:
  z.ZodType<
    UpdateScopedApiKeyAuthApiKeysResponseBody$Outbound,
    z.ZodTypeDef,
    UpdateScopedApiKeyAuthApiKeysResponseBody
  > = z.instanceof(UpdateScopedApiKeyAuthApiKeysResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const UpdateScopedApiKeyResponseBody$inboundSchema: z.ZodType<
  UpdateScopedApiKeyResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new UpdateScopedApiKeyResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type UpdateScopedApiKeyResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const UpdateScopedApiKeyResponseBody$outboundSchema: z.ZodType<
  UpdateScopedApiKeyResponseBody$Outbound,
  z.ZodTypeDef,
  UpdateScopedApiKeyResponseBody
> = z.instanceof(UpdateScopedApiKeyResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
